import React, { useState } from "react";
import "../../Styles/AdminGalleryForm.css";

function AdminGalleryForm() {
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Add Photo to Gallery</h2>
        <button className="admingallery12-back-btn" onClick={() => window.history.back()}>
          Back
        </button>
      </div>

      <form className="admingallery12-form">
        <div className="admingallery12-form-row">
          <div className="admingallery12-form-group">
            <label>Photo Title</label>
            <input type="text" placeholder="Enter Photo Title" required />
          </div>

          <div className="admingallery12-form-group">
            <label>Category</label>
            <select required defaultValue="">
              <option value="" disabled>
                Select Category
              </option>
              <option>Leaders</option>
              <option>Events</option>
              <option>Spiritual</option>
              <option>Inaugurations</option>
              <option>Sports</option>
              <option>Others</option>
            </select>
          </div>
        </div>

        <div className="admingallery12-form-row">
          <div className="admingallery12-form-group">
            <label>Upload Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
            />
          </div>

          <div className="admingallery12-form-group">
            <label>Status</label>
            <select defaultValue="Active">
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>
        </div>

        {preview && (
          <div className="admingallery12-preview-box">
            <img src={preview} alt="Preview" className="admingallery12-preview-img" />
          </div>
        )}

        <div className="admingallery12-form-group">
          <label>Caption / Description</label>
          <textarea rows="4" placeholder="Optional Caption"></textarea>
        </div>

        <button className="admingallery12-sub-btn" type="submit">
          Submit Photo
        </button>
      </form>
    </div>
  );
}

export default AdminGalleryForm;